export default __webpack_public_path__ + "static/students3-87d554827eaef9f4c29f2e3522188a19.jpg";